import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProcedureClientOld from "./pages/procedures/ProcedureClientOld";
import { default as ProfileForm } from "./pages/users/Form";
import RescuePassword from "./pages/passwords/RescuePassword";
import ChangePassword from "./pages/passwords/ChangePassword";
import Oauth from "./pages/Oauth";
import OrganizationHome from "./pages/organizations/OrganizationHome";
import Organization from "./pages/organizations/Organization";
import FolderHome from "./pages/folders/FolderHome";
import Folder from "./pages/folders/Folder";
import ProceduresHome from "./pages/procedures/ProceduresHome";
import ProcedureNew from './pages/procedures/ProcedureNew'
import ProceduresShow from "./pages/procedures/ProceduresShow";
import ProceduresUserShow from "./pages/procedures/ProceduresUserShow";
import ProcedureEmails from "./pages/procedures/ProcedureEmails";
import ConsentEdit from "./pages/consent/ConsentEdit";
import EmailsHome from "./pages/emails/EmailsHome";
import EmailsShow from "./pages/emails/EmailsShow";
import EmailsCreate from "./pages/emails/EmailsCreate";
import AdministratorsIndex from "./pages/administrators/AdministratorsIndex";
import RankingProfileIndex from "./pages/folders/RankingProfile";

import Profile from "./pages/users/Profile";
import Wrapper from './components/Wrapper';
import routes from "./config/routes";
import Proctoring from './pages/proctoring/Proctoring'
import { useParams, useLocation, useNavigate } from 'react-router-dom';
function App() {
  const navigate = useNavigate();
  return (
    <Routes>
      {/* Ruta pública */}
      <Route path="/login" element={<Login />} />
      <Route path={routes.client.profileSignin} element={<ProfileForm />} />
      <Route path={routes.client.rescuePassword} element={<RescuePassword />} />
      <Route path={routes.client.changePassword} element={<ChangePassword />} />
      <Route path={routes.client.oauth} element={<Oauth />} />
      {/* Ruta protegida */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Wrapper />}>
          <Route path="/" element={<Navigate to={routes.admin.home} replace />} />
          <Route path={routes.client.procedure} element={<ProcedureClientOld />} />
          <Route path={routes.client.myProfile} element={<Profile />} />
          <Route path={routes.client.checkproctoring} element={<Proctoring onSuccess={() => navigate("/admin")} />} />
          <Route path={routes.admin.home} element={<OrganizationHome />} />
          <Route path={routes.admin.organization} element={<Organization />} />
          <Route path={routes.admin.folder} element={<Folder />} />
          <Route path={routes.admin.folderIndex} element={<FolderHome />} />
          <Route path={routes.admin.procedures} element={<ProceduresHome />} />
          <Route path={routes.admin.proceduresShow} element={<ProceduresShow />} />
          <Route path={routes.admin.proceduresUserShow} element={<ProceduresUserShow />} />
          <Route path={routes.admin.procedureNew} element={<ProcedureNew />} />  
          <Route path={routes.admin.proceduresEmails} element={<ProcedureEmails />} />  
          
          <Route path={routes.admin.procedureConsentEdit} element={<ConsentEdit />} /> 
          <Route path={routes.admin.surveyConsentEdit} element={<ConsentEdit />} />  
          <Route path={routes.admin.organizationIndexEmails} element={<EmailsHome />} />
          <Route path={routes.admin.emailsShow} element={<EmailsShow />} /> 
          <Route path={routes.admin.emailsCreate} element={<EmailsCreate />} /> 
          <Route path={routes.admin.emails} element={<EmailsHome />} />
          <Route path={routes.admin.administrators} element={<AdministratorsIndex />} /> 
          <Route path={routes.admin.rankingProfile} element={<RankingProfileIndex />} />                    
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
